// Loader.js
import React, { createContext, useContext, useState } from "react";

const LoaderContext = createContext();

let startLoaderExternal = () => {};
let stopLoaderExternal = () => {};

export function useLoader() {
  return useContext(LoaderContext);
}

export function LoaderProvider({ children }) {
  const [loading, setLoading] = useState(false);

  const startLoader = () => setLoading(true);
  const stopLoader = () => setLoading(false);

  startLoaderExternal = startLoader;
  stopLoaderExternal = stopLoader;

  return (
    <LoaderContext.Provider value={{ loading, startLoader, stopLoader }}>
      {children}
    </LoaderContext.Provider>
  );
}

export const startGlobalLoader = () => startLoaderExternal();
export const stopGlobalLoader = () => stopLoaderExternal();
